export const PublishActionModalNames = {
  PUBLISH_CONFIRM: 'publishConfirm',
  UNPUBLISH_CONFIRM: 'unpublishConfirm',
  WARNINGS_AND_SUGGESTIONS: 'warningsAndSuggestions',
  SCHEDULING_OPTIONS: 'schedulingOptions',
  CANCEL_SCHEDULE: 'cancelSchedule'
};
export const PublishActionTypes = {
  PUBLISH: 'PUBLISH',
  UNPUBLISH: 'UNPUBLISH',
  SCHEDULE_PUBLISH: 'SCHEDULE_PUBLISH',
  SCHEDULE_UNPUBLISH: 'SCHEDULE_UNPUBLISH',
  CANCEL_SCHEDULED_PUBLISH: 'CANCEL_SCHEDULED_PUBLISH',
  CANCEL_SCHEDULED_UNPUBLISH: 'CANCEL_SCHEDULED_UNPUBLISH'
};